export default [
  {
    name: 'dashboard',
    title: 'Dashboard'
  },
  {
    name: 'usage',
    title: 'Usage'
  },
  {
    name: 'coverage',
    title: 'Coverage'
  },
  {
    name: 'datalink',
    title: 'Datalink',
    admin: true // todo: to be able to set from admin page
  }
]
